<template>
    <pg-page title="Private Gym - Aanmelden"
             header="Schrijf je in"
             id="lid-worden"
             :footer="false"
    >

        <div class="mx-auto mt-4">

            <modal title="Gelukt!"
                v-if="showModal" @closed="showModal = false">
                Bedankt voor je inschrijving. Je krijgt binnen 24 uur betaalverzoek via Whatsapp en Mail. Nadat deze betaald is gaan we je account activeren. Hierna kun je inloggen en je eerste eiland reserveren! <br/><br/><strong>LET OP:</strong> De Android app is nog niet beschikbaar. Tot dan kun je inloggen via je browser met onderstaande knop.
<!--                <div class="card mb-2 rounded-3 shadow-sm text-center">-->
                    <div class="card-body my-3 text-center">
                        <div v-bind:class="{
                                        'circle-loader': true,
                                        'load-complete': registeredSuccessfully,
                                        'checkmark': true,
                                        'failmark': false,
                                    }">
                            <div class="checkmark draw" v-show="registeredSuccessfully"></div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-6">
                                <a href="https://apps.apple.com/us/app/private-gym-clients/id1615723985">
                                    <img class="w-100" src="/images/app/ios-download.png" alt="Download de iOS app">
                                </a>
                            </div>
                            <div class="col-6">
                                <a href="https://app.private-gym.nl/">
                                    <img class="w-100" src="/images/app/playstore-download.png" alt="Download de Playstore app">
                                </a>
                            </div>
                        </div>
                    </div>
<!--                </div>-->
            </modal>

            <form novalidate>
                <div class="row g-3  justify-content-center">
                    <div class="col-sm-6 text-center order-1">
                        <div class="card mb-2 rounded-3 shadow-sm">
                            <div class="card-header py-3">
                                <h4 class="my-0 fw-normal">Introductie</h4>
                            </div>
                            <div class="card-body">
                                <h1 class="card-title pricing-card-title">€9,99<small class="text-muted fw-light">/wk</small></h1>
                                <ul class="list-unstyled mt-3 mb-4">
                                    <li>Dagelijks reserveren</li>
                                    <li>24/7 toegang via de app</li>
                                    <li>Altijd een eiland voor jezelf</li>
<!--                                    <li>Gratis personal training intro</li>-->
                                </ul>
                            </div>
                        </div>
                        <div class="card mb-2 rounded-3 shadow-sm">
                            <div class="row g-2 m-2 mb-3">
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col-sm-6 col-12">
                                            <div class="form-floating mb-2 mb-sm-0">
                                                <input v-model="first_name" type="text" v-bind:class="{
                                                    'form-control': true,
                                                    'is-invalid': errors.first_name,
                                                    'is-valid': typeof errors.first_name === 'undefined' && wasValidated,
                                                }"
                                                       id="firstName" placeholder="Voornaam" required>
                                                <label for="firstName">Voornaam <span class="text-muted">*</span></label>
                                                <div class="invalid-feedback">
                                                    {{ errors.first_name }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6 col-12">
                                            <div class="form-floating">
                                                <input v-model="last_name" type="text"  v-bind:class="{
                                                    'form-control': true,
                                                    'is-invalid': errors.last_name,
                                                    'is-valid': typeof errors.last_name === 'undefined' && wasValidated,
                                                }"
                                               id="lastName" placeholder="Achternaam" required>
                                                <label for="lastName">Achternaam <span class="text-muted">*</span></label>
                                                <div class="invalid-feedback">
                                                    {{ errors.last_name }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                                <div class="form-floating">
                                    <input v-model="email" type="email"
                                           v-bind:class="{
                                                    'form-control': true,
                                                    'is-invalid': errors.email,
                                                    'is-valid': typeof errors.email === 'undefined' && wasValidated,
                                                }"
                                           id="email" placeholder="Email"  name="email" >
                                    <label for="email" class="form-label">Email <span class="text-muted">*</span></label>
                                    <div class="invalid-feedback">
                                        {{ errors.email }}
                                    </div>
                                </div>



                                <div class="form-floating">
                                    <input v-model="phone_number" type="text"
                                           v-bind:class="{
                                                    'form-control': true,
                                                    'is-invalid': errors.phone_number,
                                                    'is-valid': typeof errors.phone_number === 'undefined' && wasValidated,
                                                }"
                                           id="telephone" placeholder="Telefoonnummer" name="phone_number" required="">
                                    <label for="email" class="form-label">Telefoon <span class="text-muted">*</span></label>
                                    <div class="invalid-feedback">
                                        {{ errors.phone_number }}
                                    </div>
                                </div>

                                <div class="form-floating">
                                    <input v-model="password" type="password"
                                           v-bind:class="{
                                                    'form-control': true,
                                                    'is-invalid': errors.password,
                                                    'is-valid': typeof errors.password === 'undefined' && wasValidated,
                                                }"
                                           id="password" name="password" required placeholder="Wachtwoord">
                                    <label for="password" class="form-label">Wachtwoord <span class="text-muted">(10+ karakters)</span></label>
                                    <div class="invalid-feedback">
                                        {{ errors.password }}
                                    </div>
                                </div>

                                <div class="form-floating">
                                    <input v-model="password_confirmation" type="password"
                                           v-bind:class="{
                                                    'form-control': true,
                                                    'is-invalid': errors.password_confirmation,
                                                    'is-valid': typeof errors.password_confirmation === 'undefined' && wasValidated,
                                                }"
                                           id="password_confirmation" name="password_confirmation" required placeholder="Wachtwoord">
                                    <label for="password" class="form-label">Wachtwoord <span class="text-muted">(nogmaals)</span></label>
                                    <div class="invalid-feedback">
                                        {{ errors.password_confirmation }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card mb-2 rounded-3 shadow-sm">
                            <div class="m-2">
                                <button @click.prevent="send" type="button" class="w-100 btn btn-lg btn-primary" :disabled="loading">
                                    <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Word nu lid
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </form>


        </div>

    </pg-page>
</template>

<script>

import PgPage from "../../../Components/PgPage";
import ContactModal from "../../../Components/Contact/ContactModal";
import axios from "axios";
import Modal from "../../../Components/Modal";
export default {
    components: {Modal, ContactModal, PgPage},

    props: [],

    mixins: [],

    data: function () {
        return {
            loading: false,
            wasValidated: false,
            errors: {},
            showModal: false,

            registeredSuccessfully: false,

            showFormModal: false,
            first_name: '',
            last_name: '',
            phone_number: '',
            email: '',
            password: '',
            password_confirmation: '',
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        send() {
            const vm = this;
            this.loading = true;
            this.errors = {};
            this.wasValidated = false;
            window.axios.post(process.env.MIX_API_URL + '/api/v1/register', {
                first_name: this.first_name,
                last_name: this.last_name,
                phone_number: this.phone_number,
                email: this.email,
                password: this.password,
                password_confirmation: this.password_confirmation,
            })
                .then(function (response) {
                    console.log('response', response);

                    setTimeout(() => {
                        vm.registeredSuccessfully = true;
                    }, 1500);
                    vm.showModal = true;
                    vm.loading = false;
                    vm.wasValidated = true;
                })
                .catch(function (error) {
                    console.log('catch', error);
                    vm.loading = false;
                    if (typeof error.response.data.errors !== 'undefined') {
                        Object.keys(error.response.data.errors).forEach(formName => {
                            error.response.data.errors[formName].forEach(errorMessage => {
                                vm.errors[formName] = errorMessage;
                            });
                        })
                    }
                    vm.wasValidated = true;
                });
        },
    },

    watch: {
        //
    }
};
</script>
<style lang="scss">
    #lid-worden label {
        font-weight: bold;
        color: red;
    }
</style>
